export class GeneratePdf {
    TheUrl: string = "http:dbusinesschemistryadmin.deloitte.com";
    SelectedIds: SelectedIds[];
    FileName: string = "BC Team Snapshot.pdf";
    Language: string;
    BaselineID: number;
    Region: string;
}

export class SelectedIds {
    ID: number
    UserCountryId: number
}
